"use client"
import { usePathname } from 'next/navigation';

import { HomeIcon } from '@heroicons/react/outline';

import { ScreenPaths } from '../routing';

import type { NavigationLinkItem } from "./types/NavigationLinkItem"

export const useBaseNavLinks: () => { baseNavLinks: NavigationLinkItem[] } = () => {
    const pathname = usePathname()
    const links: { [property in "home"]: NavigationLinkItem } = {
        home: {
            label: "Home",
            path: ScreenPaths.Dashboard,
            displayType: "link",
            isActive: pathname === ScreenPaths.Dashboard,
            // isDisabled: pathname === ScreenPaths.Dashboard,
            icon: HomeIcon
            // onClick: () => rootNavigationState.getState().setCurrentNavView(NavigationViews.Root)
        }
        // TODO: Leaving commented out until we're ready to add alerts
        // alerts: {
        //     permittedRoles: ['superadmin', 'admin', 'owner', 'staff'],
        //     label: 'Alerts',
        //     displayType: 'link',
        //     isDisabled: false,
        //     icon: BellIcon,
        // },
    }
    return { baseNavLinks: [links.home] }
}

export default useBaseNavLinks
